const validCellphonePY = _cellPhone => {
    let newCellPhone;
    if((process.env.LOCALE === "es-PY" || process.env.LOCALE === "es-UY") && !_cellPhone.startsWith("0")){
       newCellPhone = `${0}${_cellPhone}`
    }else{
        newCellPhone = _cellPhone;
    }
    return newCellPhone;
}

export default validCellphonePY;